// Libs
import React from 'react';
import Button from '@material-ui/core/Button';
import { useHistory } from 'react-router';
import Icon from '../../layout/components/Icon';
import { allQRCodeModes } from '../../devices/helper';

// Path of the qrcode main page (the modes list): the current path without its /<MODE> segment
export const getQRCodeHomePath = pathname => {
    const currentQRCodeForm = allQRCodeModes.find(mode => pathname.includes(`${mode}`));
    return pathname.split(`/${currentQRCodeForm}`)[0];
};

const QRCodeBackButton = () => {
    const history = useHistory();

    return (
        <Button
            className={'qrcode-with-modes-back-button'}
            onClick={() => {
                // Redirect to the qrcode main page
                history.push({ pathname: getQRCodeHomePath(history.location.pathname) });
            }}
        >
            <Icon type={'ArrowBackIcon'} />
        </Button>
    );
};

export default QRCodeBackButton;
